






















































import Vue from 'vue'
import Component from 'vue-class-component'
import { IProduct, IVersion, IAddVersionRequest, IEditVersionRequest, ManifestFileFormatType } from '../model/ProductsState'
import  ProductService  from '../services/ProductsService'

@Component({})
export default class AddEditVersion extends Vue {
    productId: number
    productService: ProductService
    isEdit: boolean;
    isLoading: boolean;
    formatType: ManifestFileFormatType;

    versionId = -1
    versionName = ""
    versionNumber = ""
    versionDescription = ""
    versionApplicationId = ""
    

    form = false;

    constructor () {
      super()
      this.isEdit = false
      this.isLoading = true;
      this.productService = new ProductService();
      this.productId = -1
      this.formatType = ManifestFileFormatType.Xml;
    }

    mounted(){
        this.productId = +this.$route.params.productId

        if(this.$route.path.includes("edit-version")){
            this.isEdit = true;
            this.productService.getProductById(+this.$route.params.productId).then(prod => {
            prod.versions.forEach((version: IVersion) => {
                if(version.id == +this.$route.params.versionId){
                    this.versionId = version.id
                    this.versionName = version.name
                    this.versionNumber = version.number
                    this.versionDescription = version.description
                    this.versionApplicationId = version.applicationId
                }
            });
            this.isLoading = false;

            })
        }
        else {
            this.isLoading = false;
        }
    }

    submit(){

        if(this.$route.path.includes("add-version")){

            const addRequest: IAddVersionRequest = {name: this.versionName, number: this.versionNumber,
                description: this.versionDescription, productId: this.productId,
                userId: this.$store.state.user.user.id, applicationId: this.versionApplicationId, formatType: this.formatType}
            this.productService.addVersion(addRequest).then(() => {
                this.$router.push({name: "Product", params:{id: ""+this.productId}})
            });
        }
        else if(this.$route.path.includes("edit-version")){
            const editRequest: IEditVersionRequest = {id: this.versionId, name: this.versionName,
                number: this.versionNumber, description: this.versionDescription}
            this.productService.editVersion(editRequest).then(() => {
                this.$router.push({name: "Product", params:{id: ""+this.productId}})
            })
        }
    }
    abort(){
        this.$router.push({name: "Product", params: {id: ""+this.productId}})
    }



}
